import type { AnyAction } from '@reduxjs/toolkit';

export const KEY_PENDING = 'pending';
export const KEY_FULFILLED = 'fulfilled';
export const KEY_REJECTED = 'rejected';

const getIsActionPending = (action: AnyAction) => action.type.endsWith(KEY_PENDING);

const getIsActionFulfilled = (action: AnyAction) => action.type.endsWith(KEY_FULFILLED);

const getIsActionRejected = (action: AnyAction) => action.type.endsWith(KEY_REJECTED);

const getBaseAction = (actionType: string, type: typeof KEY_PENDING | typeof KEY_FULFILLED | typeof KEY_REJECTED) => {
  const [baseAction] = actionType.split(`/${type}`);

  return baseAction;
};

export const storeHelpers = {
  getIsActionPending,
  getIsActionFulfilled,
  getIsActionRejected,
  getBaseAction,
};
